export const cookies = (() => {
  return {
    getCookieByName: (name: string) => {
      const position = 2
      const regEval = RegExp('(^|; )' + encodeURIComponent(name) + '=([^;]*)').exec(document.cookie)
      return regEval ? regEval[position] : null
    }
  }
})()
